/* ============================================================
   lb-base.js — Leuchtbilder24 runtime (framework-free)
   Ports every function from the source HTMLs: before/after light
   slider, scroll-reveal, filter chips, gallery, size→variant price,
   colour, qty, countdown, sticky bar. Guards every hook; re-binds
   on shopify:section:load for the theme editor.
   ============================================================ */
(function () {
  'use strict';

  function euro(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function init(root) {
    root = root || document;
    document.body.classList.add('lb-page');

    /* ---- scroll reveal ---- */
    var els = root.querySelectorAll('.lb-reveal:not(.is-visible)');
    if (els.length) {
      if (!('IntersectionObserver' in window)) {
        els.forEach(function (el) { el.classList.add('is-visible'); });
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
          });
        }, { threshold: 0.12, rootMargin: '0px 0px -80px 0px' });
        els.forEach(function (el) { io.observe(el); });
      }
    }

    /* ---- before/after light slider ---- */
    root.querySelectorAll('.lb-slider').forEach(function (slider) {
      if (slider.dataset.lbBound) return;
      slider.dataset.lbBound = '1';
      var onLayer = slider.querySelector('.lb-slider__layer--on');
      var handle = slider.querySelector('.lb-slider__handle');
      if (!onLayer || !handle) return;
      var dragging = false, demo = 50, demoDir = 1, demoActive = true;
      function setPos(p) {
        p = Math.max(0, Math.min(100, p));
        onLayer.style.clipPath = 'polygon(0 0, ' + p + '% 0, ' + p + '% 100%, 0 100%)';
        handle.style.left = p + '%';
      }
      function pct(x) { var r = slider.getBoundingClientRect(); return ((x - r.left) / r.width) * 100; }
      function move(e) { if (!dragging) return; var x = e.touches ? e.touches[0].clientX : e.clientX; setPos(pct(x)); }
      slider.addEventListener('mousedown', function (e) { dragging = true; slider.style.cursor = 'grabbing'; setPos(pct(e.clientX)); });
      slider.addEventListener('touchstart', function (e) { dragging = true; setPos(pct(e.touches[0].clientX)); }, { passive: true });
      window.addEventListener('mousemove', move);
      window.addEventListener('touchmove', move, { passive: true });
      window.addEventListener('mouseup', function () { dragging = false; slider.style.cursor = 'ew-resize'; });
      window.addEventListener('touchend', function () { dragging = false; });
      ['mousedown', 'touchstart'].forEach(function (ev) { slider.addEventListener(ev, function () { demoActive = false; }, { once: true }); });
      (function loop() {
        if (demoActive) { demo += demoDir * 0.4; if (demo > 75) demoDir = -1; if (demo < 35) demoDir = 1; setPos(demo); }
        requestAnimationFrame(loop);
      })();
    });

    /* ---- filter chips (visual toggle) ---- */
    root.querySelectorAll('.lb-filter__actions, [data-lb-chips]').forEach(function (bar) {
      if (bar.dataset.lbBound) return;
      bar.dataset.lbBound = '1';
      bar.addEventListener('click', function (e) {
        var chip = e.target.closest('.lb-chip'); if (!chip) return;
        if (chip.textContent.indexOf('Sortieren') !== -1) return;
        bar.querySelectorAll('.lb-chip').forEach(function (c) { if (c.textContent.indexOf('Sortieren') === -1) c.classList.remove('is-active'); });
        chip.classList.add('is-active');
      });
    });

    /* ---- gallery thumbs ---- */
    root.querySelectorAll('.lb-gallery').forEach(function (g) {
      if (g.dataset.lbBound) return;
      g.dataset.lbBound = '1';
      var thumbs = g.querySelectorAll('.lb-gallery__thumb');
      var mains = g.querySelectorAll('.lb-gallery__main img');
      var stage = g.querySelector('.lb-gallery__main');
      /* Buehne uebernimmt das Seitenverhaeltnis des gezeigten Bildes,
         damit nichts beschnitten wird. */
      function setStageRatio(img) {
        if (!stage || !img) return;
        var ar = img.dataset.ar;
        if (!ar && img.naturalWidth && img.naturalHeight) {
          ar = img.naturalWidth + ' / ' + img.naturalHeight;
        }
        if (ar) stage.style.setProperty('--lb-gal-ar', ar);
      }
      var first = g.querySelector('.lb-gallery__main img.is-active') || mains[0];
      if (first) {
        setStageRatio(first);
        if (!first.dataset.ar && !first.complete) {
          first.addEventListener('load', function () { setStageRatio(first); }, { once: true });
        }
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = t.dataset.idx;
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
          mains.forEach(function (x) { x.classList.remove('is-active'); });
          var m = g.querySelector('.lb-gallery__main img[data-idx="' + idx + '"]');
          if (m) { m.classList.add('is-active'); setStageRatio(m); }
        });
      });
    });

    /* ---- countdown ---- */
    root.querySelectorAll('#cdTimer').forEach(function (el) {
      if (el.dataset.lbBound) return;
      el.dataset.lbBound = '1';
      var total = 4 * 3600 + 23 * 60 + 17;
      (function tick() {
        if (total < 0) total = 6 * 3600;
        var h = Math.floor(total / 3600), m = Math.floor((total % 3600) / 60), s = total % 60;
        el.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
        total--;
      })();
      setInterval(function () {
        if (total < 0) total = 6 * 3600;
        var h = Math.floor(total / 3600), m = Math.floor((total % 3600) / 60), s = total % 60;
        el.textContent = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
        total--;
      }, 1000);
    });

    /* ---- colour swatches (visual) ---- */
    root.querySelectorAll('.lb-color-row').forEach(function (row) {
      if (row.dataset.lbBound) return;
      row.dataset.lbBound = '1';
      row.querySelectorAll('.lb-color').forEach(function (c) {
        c.addEventListener('click', function () {
          row.querySelectorAll('.lb-color').forEach(function (x) { x.classList.remove('is-active'); });
          c.classList.add('is-active');
        });
      });
    });

    /* ---- PDP: variants + qty + price ---- */
    var pdp = root.querySelector('[data-lb-pdp]');
    if (pdp && !pdp.dataset.lbBound) { initPdp(pdp); pdp.dataset.lbBound = '1'; }
  }

  function initPdp(pdp) {
    var variants = [];
    try { variants = JSON.parse(pdp.querySelector('#lb-variants').textContent); } catch (e) {}
    var idInput = pdp.querySelector('input[name="id"]');
    var qtyEl = pdp.querySelector('#qtyVal');
    var pxPrice = pdp.querySelector('#pxPrice');
    var btnTotal = pdp.querySelector('#btnTotal');
    var stickyPrice = pdp.querySelector('#stickyPrice');
    var mainImgs = pdp.querySelectorAll('.lb-gallery__main img');
    var qty = function () { return qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1; };

    var selected = {};
    var first = variants.find(function (v) { return v.available; }) || variants[0];
    if (first) { selected[0] = first.option1; selected[1] = first.option2; selected[2] = first.option3; }

    function current() {
      return variants.find(function (v) {
        return v.option1 == selected[0] &&
          (v.option2 == null || v.option2 == selected[1]) &&
          (v.option3 == null || v.option3 == selected[2]);
      });
    }
    function update() {
      pdp.querySelectorAll('[data-lb-opt]').forEach(function (b) {
        b.classList.toggle('is-active', String(selected[+b.dataset.lbOpt]) === b.dataset.lbVal);
      });
      var v = current();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (pxPrice) pxPrice.innerHTML = euro(v.price);
      var total = v.price * qty();
      if (btnTotal) btnTotal.innerHTML = euro(total);
      if (stickyPrice) stickyPrice.innerHTML = euro(total);
      if (v.featured_image && v.featured_image.src && mainImgs.length) {
        mainImgs.forEach(function (x) { x.classList.remove('is-active'); });
        mainImgs[0].src = v.featured_image.src;
        mainImgs[0].classList.add('is-active');
      }
    }
    pdp.querySelectorAll('[data-lb-opt]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.dataset.lbInquiry === '1') { return; }
        selected[+b.dataset.lbOpt] = b.dataset.lbVal; update();
      });
    });
    var minus = pdp.querySelector('#qtyMinus'), plus = pdp.querySelector('#qtyPlus');
    if (minus) minus.addEventListener('click', function () { var q = qty(); if (q > 1) { qtyEl.textContent = q - 1; update(); } });
    if (plus) plus.addEventListener('click', function () { var q = qty(); if (q < 10) { qtyEl.textContent = q + 1; update(); } });

    /* sticky bar add → submit product form */
    var stickyBtn = document.querySelector('.lb-sticky-bar__btn');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var f = pdp.querySelector('form[action*="/cart/add"]'); if (f) f.requestSubmit ? f.requestSubmit() : f.submit();
    });

    /* upload: reflect chosen filename */
    var upload = pdp.querySelector('.lb-upload');
    var fileInput = pdp.querySelector('input[type="file"][name^="properties"]');
    if (upload && fileInput) {
      upload.addEventListener('click', function (e) { if (e.target !== fileInput) fileInput.click(); });
      fileInput.addEventListener('change', function () {
        if (fileInput.files && fileInput.files[0]) {
          var s = upload.querySelector('span'); if (s) s.textContent = '✓ ' + fileInput.files[0].name;
        }
      });
    }
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
